import { axiosInstance } from '@/config/axios.config';
import {
  UnderwearRequest,
  UnderwearResponse,
  UpdateUnderwearRequest,
} from '@repo/types/src/underwear';

export const getAllUnderwears = async () => {
  const response =
    await axiosInstance.get<UnderwearResponse[]>(`/underwear/admin`);
  return response.data;
};

export const createUnderwear = async (payload: UnderwearRequest) => {
  const formData = new FormData();
  formData.append('file', payload.file);
  formData.append('name', payload.name);
  if (payload.nameEn) formData.append('nameEn', payload.nameEn);
  formData.append('category', payload.category);
  formData.append('sortOrder', payload.sortOrder.toString());
  formData.append(
    'isAvailableOnOrpair',
    payload.isAvailableOnOrpair.toString(),
  );

  const response = await axiosInstance.post<UnderwearResponse>(
    `/underwear/admin`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response.data;
};

export const updateUnderwear = async (
  id: number,
  payload: UpdateUnderwearRequest,
) => {
  const formData = new FormData();
  if (payload.file) formData.append('file', payload.file);
  formData.append('name', payload.name);
  if (payload.nameEn) formData.append('nameEn', payload.nameEn);
  formData.append('category', payload.category);
  formData.append('sortOrder', payload.sortOrder.toString());
  formData.append(
    'isAvailableOnOrpair',
    payload.isAvailableOnOrpair.toString(),
  );

  const response = await axiosInstance.patch<UnderwearResponse>(
    `/underwear/admin/${id}`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data;
};

export const deleteUnderwear = async (id: number) => {
  const response = await axiosInstance.delete<UnderwearResponse>(
    `/underwear/admin/${id}`,
  );
  return response.data;
};
